module.exports = __webpack_public_path__ + "static/dc-nordeste-4-6aa12836234fdee56466f8d41072cc62.jpg";